import React from 'react';
import {graphql} from 'react-relay';
import {useHistory} from 'react-router-dom';
import {useTrackPage} from '../../../../tracking/amplitude/hooks/useTrackPage';
import type {BaselineTemplatesPageQuery$data} from './__generated__/BaselineTemplatesPageQuery.graphql';
import {BaselineTemplatesList} from './BaselineTemplatesList';
import {editBaselineTemplatePath, NEW_BASELINE_TEMPLATE_PATH} from '../templatesPaths';

export const BaselineTemplatesPageQuery = graphql`
	query BaselineTemplatesPageQuery {
		viewer {
			actualPersonId
			component(name: "settings_baseline_templates")
			company {
				...BaselineTemplatesList_company
			}
		}
	}
`;

type Props = {viewer: BaselineTemplatesPageQuery$data['viewer']};

export const BaselineTemplatesPage = ({viewer}: Props): JSX.Element | null => {
	useTrackPage('Baseline Templates');
	const history = useHistory();
	if (!viewer?.company) {
		return null;
	}
	return (
		<BaselineTemplatesList
			company={viewer.company}
			onCreate={() => history.push(NEW_BASELINE_TEMPLATE_PATH)}
			onEdit={id => history.push(editBaselineTemplatePath(id))}
		/>
	);
};
